<template>
  <b-card class="border border-[#FFFFFF] rounded-md">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0 text-xl font-bold">
        Revenue
      </h5>
      <div class="flex items-center gap-10">
        <RevenueDropdown
          id="revenue-dropdown"
          :options="revenueFilter"
          :value="initialValueRevenueFilter"
          @change="handleRevenueFilterChange"
        />
        <!-- <div class="year-picker-wrapper">
          <YearPicker v-model="selectedYear" :format="START_YEAR_NOW" minimum-view="year" name="datepicker"
            input-class="year-picker-input" wrapper-class="year-picker-container" calendar-class="year-picker-calendar"
            @input="handleYearChange" />
          <b-img src="https://storage.googleapis.com/komerce/assets/icons/date-picker-icon.svg"
            class="year-picker-icon" />
        </div> -->
        <date-range-picker
          ref="picker"
          v-model="dateRange"
          opens="left"
          control-container-class="border-0"
          class="w-100 cursor-pointer"
          :ranges="customRanges"
          @update="handleDateChange"
        >
          <template v-slot:input="picker">
            <div class="flex justify-between items-center gap-2 w-full border border-gray-300 rounded px-2 h-[36px]">
              <span :class="dateRange.startDate ? 'text-black' : 'text-gray-400'">
                {{ dateRange.startDate && dateRange.endDate ? picker.rangeText : 'Pilih tanggal' }}
              </span>
              <span class="k-calendar pl-[7px] text-[21px]" />
            </div>
          </template>
        </date-range-picker>
      </div>
    </div>

    <!-- Legend Cards 1 -->
    <div
      v-if="selectedRevenueFilter === 'subscription'"
      class="flex gap-3 mb-4"
    >
      <div
        v-for="(item, index) in legendData"
        :key="index"
        class="legend-card p-1 rounded cursor-pointer"
        :class="{ 'legend-card-inactive': !item.active }"
        @click="toggleLegend(index)"
      >
        <div class="flex items-center gap-3 mb-2">
          <div
            class="legend-dot"
            :style="{ backgroundColor: item.active ? item.color : '#D1D5DB' }"
          />
          <span class="text-muted small">{{ item.label }}</span>
        </div>
        <div class="font-weight-bold h5 mb-0">
          Rp {{ IDRWithoutLbl(item.value) }}
        </div>
      </div>
    </div>

    <!-- Legend cards 2 -->
    <div
      v-if="selectedRevenueFilter !== 'subscription'"
      class="flex gap-3 mb-4"
    >
      <div
        v-for="(item, index) in filteredLegendDataRevenue"
        :key="index"
        class="legend-card p-1 rounded cursor-pointer"
        :class="{ 'legend-card-inactive': !item.active }"
        @click="toggleLegendRevenue(index)"
      >
        <div class="flex items-center gap-3 mb-2">
          <div
            class="legend-dot"
            :style="{ backgroundColor: item.active ? item.color : '#D1D5DB' }"
          />
          <span class="text-muted small">{{ item.label }}</span>
        </div>
        <div class="font-weight-bold h5 mb-0">
          Rp {{ IDRWithoutLbl(item.value) }}
        </div>
      </div>
    </div>

    <!-- Chart -->
    <div style="position: relative; min-height: 350px;">
      <div v-if="!loading">
        <apexchart
          type="area"
          height="350"
          :options="chartOptions"
          :series="series"
        />
      </div>
      <div
        v-else
        class="d-flex justify-content-center align-items-center"
        style="height: 350px;"
      >
        <b-spinner variant="primary" />
      </div>
      <div
        v-if="loadingChart"
        class="d-flex justify-content-center align-items-center"
        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.75); z-index: 10;"
      >
        <b-spinner variant="primary" />
      </div>
    </div>
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { START_YEAR_NOW, YEAR_MONTH_DAY, DAY_MONTH_YEAR } from '@/libs/filterDate'
// import YearPicker from 'vuejs-datepicker'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { IDRWithoutLbl } from '@/libs/currency'
import { revenueChartOptions, revenueFilter } from '../config'
import RevenueDropdown from './RevenueDropdown.vue'
import {
  apiSubscriptionDetailKomchat, apiClosingOrderDetailKomchat, apiDetailRevenue, apiBroadcastDetailKomchat,
} from '../services/api.komchat.service'

export default {
  name: 'CardRevenue',
  components: {
    apexchart: VueApexCharts,
    // YearPicker,
    DateRangePicker,
    RevenueDropdown,
  },
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedYear: new Date(),
      dateRange: {
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
      },
      START_YEAR_NOW,
      IDRWithoutLbl,
      legendData: [
        {
          label: 'Starter', value: 4000000, color: '#EF4444', active: true,
        },
        {
          label: 'Basic', value: 4000000, color: '#F59E0B', active: true,
        },
        {
          label: 'Pro', value: 4000000, color: '#10B981', active: true,
        },
      ],
      legendDataRevenue: [
        {
          label: 'All Revenue', value: 0, color: '#08A0F7', active: true,
        },
        {
          label: 'Subscription', value: 0, color: '#E31A1A', active: true,
        },
        {
          label: 'Closing Order', value: 0, color: '#FBA63C', active: true,
        },
        {
          label: 'Broadcast', value: 0, color: '#34A770', active: true,
        },
      ],
      series: [],
      originalSeries: [],
      fullSeriesData: [],
      subscSeriesData: {
        starter: [],
        basic: [],
        pro: [],
      },
      chartOptions: revenueChartOptions,
      revenueFilter,
      initialValueRevenueFilter: 'All Revenue',
      selectedRevenueFilter: 'all_revenue',
      loadingChart: false,
    }
  },
  computed: {
    customRanges() {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const todayEnd = new Date()
      todayEnd.setHours(23, 59, 59, 999)

      const yesterday = new Date(today)
      yesterday.setDate(yesterday.getDate() - 1)
      const yesterdayEnd = new Date(yesterday)
      yesterdayEnd.setHours(23, 59, 59, 999)

      const last7Start = new Date(today)
      last7Start.setDate(last7Start.getDate() - 6)

      const last30Start = new Date(today)
      last30Start.setDate(last30Start.getDate() - 29)

      const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1)
      const thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0)

      const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1)
      const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0)

      return {
        'Hari ini': [today, todayEnd],
        Kemarin: [yesterday, yesterdayEnd],
        '7 Hari terakhir': [last7Start, todayEnd],
        '30 Hari terakhir': [last30Start, todayEnd],
        'Bulan ini': [thisMonthStart, thisMonthEnd],
        'Bulan lalu': [lastMonthStart, lastMonthEnd],
        'Custom Range': [null, null],
      }
    },
    filteredLegendDataRevenue() {
      if (this.selectedRevenueFilter === 'all_revenue') {
        return this.legendDataRevenue
      }
      if (this.selectedRevenueFilter === 'closing_order') {
        return this.legendDataRevenue.filter(item => item.label === 'Closing Order')
      }
      if (this.selectedRevenueFilter === 'broadcast') {
        return this.legendDataRevenue.filter(item => item.label === 'Broadcast')
      }
      return []
    },
  },
  mounted() {
    this.getDetailRevenueMetrics()
  },
  methods: {
    calcYMax() {
      const allValues = this.series.flatMap(s => s.data || [])
      const maxValue = allValues.length > 0 ? Math.max(...allValues) : 0
      return maxValue > 0 ? Math.ceil(maxValue * 1.25) : 100
    },
    handleRevenueFilterChange(value) {
      this.selectedRevenueFilter = value
      this.initialValueRevenueFilter = this.revenueFilter.find(o => o.value === value)?.label || value
      this.getDetailRevenueMetrics()
    },
    handleYearChange() {
      const year = START_YEAR_NOW(this.selectedYear)
      this.$emit('year-change', year)
      this.getDetailRevenue()
    },
    handleDateChange(value) {
      this.dateRange.startDate = value.startDate
      this.dateRange.endDate = value.endDate
      this.getDetailRevenueMetrics()
    },
    toggleLegend(index) {
      const willBeActive = !this.legendData[index].active
      this.legendData[index].active = willBeActive
      if (this.selectedRevenueFilter === 'subscription') {
        const activeSeries = [
          { name: 'Starter', data: this.subscSeriesData.starter, color: this.legendData[0].color },
          { name: 'Basic', data: this.subscSeriesData.basic, color: this.legendData[1].color },
          { name: 'Pro', data: this.subscSeriesData.pro, color: this.legendData[2].color },
        ].filter((_, i) => this.legendData[i].active)
        this.series = activeSeries.map(({ name, data }) => ({ name, data }))
        this.chartOptions = {
          ...this.chartOptions,
          colors: activeSeries.map(s => s.color),
          yaxis: { ...revenueChartOptions.yaxis, min: 0, max: this.calcYMax() },
        }
      } else {
        this.updateChartSeries()
      }
    },
    toggleLegendRevenue(index) {
      const item = this.filteredLegendDataRevenue[index]
      const globalIndex = this.legendDataRevenue.findIndex(l => l.label === item.label)
      if (globalIndex === -1) return
      const willBeActive = !this.legendDataRevenue[globalIndex].active
      this.legendDataRevenue[globalIndex].active = willBeActive
      this.series = this.fullSeriesData.filter(s => {
        const match = this.legendDataRevenue.find(l => l.label === s.name)
        return match ? match.active : true
      })
      this.chartOptions = {
        ...this.chartOptions,
        colors: this.fullSeriesData
          .filter(s => this.series.some(a => a.name === s.name))
          .map(s => this.legendDataRevenue.find(l => l.label === s.name)?.color)
          .filter(Boolean),
        yaxis: { ...revenueChartOptions.yaxis, min: 0, max: this.calcYMax() },
      }
    },
    updateChartSeries() {
      if (!this.originalSeries || this.originalSeries.length === 0) return

      // Filter series berdasarkan active legend
      this.series = this.originalSeries
        .filter((_, index) => this.legendData[index]?.active)
        .map((serie, originalIndex) => {
          // Find the original index in legendData
          const legendIndex = this.originalSeries.findIndex(s => s.name === serie.name)
          return {
            ...serie,
            data: this.legendData[legendIndex]?.active ? serie.data : [],
          }
        })

      // Update chart colors to match active legends only
      const activeColors = this.legendData
        .filter(item => item.active)
        .map(item => item.color)

      this.chartOptions = {
        ...this.chartOptions,
        colors: activeColors,
        yaxis: { ...revenueChartOptions.yaxis, min: 0, max: this.calcYMax() },
      }
    },
    async getDetailRevenue() {
      const date = START_YEAR_NOW(this.selectedYear)
      try {
        const { data } = await apiDetailRevenue(date)
        const responseData = data.data

        this.originalSeries = [
          {
            name: 'Starter',
            data: responseData.starter || [],
          },
          {
            name: 'Basic',
            data: responseData.basic || [],
          },
          {
            name: 'Pro',
            data: responseData.pro || [],
          },
        ]

        this.legendData[0].value = (responseData.starter || []).reduce((a, b) => a + b, 0)
        this.legendData[1].value = (responseData.basic || []).reduce((a, b) => a + b, 0)
        this.legendData[2].value = (responseData.pro || []).reduce((a, b) => a + b, 0)

        this.series = [...this.originalSeries]
      } catch {
        this.$toast_error({ message: 'Gagal mengambil data revenue' })
      }
    },
    async getDetailRevenueMetrics() {
      const params = { start_date: YEAR_MONTH_DAY(this.dateRange.startDate), end_date: YEAR_MONTH_DAY(this.dateRange.endDate) }
      const filter = this.selectedRevenueFilter
      this.loadingChart = true
      try {
        let subscRawData = {}
        let closingOrderData = []
        let broadcastData = []

        if (filter === 'all_revenue') {
          const [subscRes, closingOrderRes, broadcastRes] = await Promise.all([
            apiSubscriptionDetailKomchat(params),
            apiClosingOrderDetailKomchat(params),
            apiBroadcastDetailKomchat(params),
          ])
          subscRawData = subscRes.data?.data || {}
          closingOrderData = closingOrderRes.data?.data || []
          broadcastData = broadcastRes.data?.data || []
        } else if (filter === 'subscription') {
          const { data } = await apiSubscriptionDetailKomchat(params)
          subscRawData = data?.data || {}
        } else if (filter === 'closing_order') {
          const { data } = await apiClosingOrderDetailKomchat(params)
          closingOrderData = data?.data || []
        } else if (filter === 'broadcast') {
          const { data } = await apiBroadcastDetailKomchat(params)
          broadcastData = data?.data || []
        }
        const subscBasic = subscRawData.basic || []
        const subscPro = subscRawData.pro || []
        const subscStarter = subscRawData.starter || []

        const length = Math.max(subscBasic.length, closingOrderData.length, broadcastData.length)

        const subscByDate = Array.from({ length }, (_, i) => (subscBasic[i] || 0) + (subscPro[i] || 0) + (subscStarter[i] || 0))
        const closingByDate = Array.from({ length }, (_, i) => closingOrderData[i] || 0)
        const broadcastByDate = Array.from({ length }, (_, i) => broadcastData[i] || 0)
        const totalByDate = Array.from({ length }, (_, i) => subscByDate[i] + closingByDate[i] + broadcastByDate[i])

        this.legendDataRevenue[0].value = totalByDate.reduce((acc, val) => acc + val, 0)
        this.legendDataRevenue[1].value = subscByDate.reduce((acc, val) => acc + val, 0)
        this.legendDataRevenue[2].value = closingByDate.reduce((acc, val) => acc + val, 0)
        this.legendDataRevenue[3].value = broadcastByDate.reduce((acc, val) => acc + val, 0)

        this.legendData[0].value = subscStarter.reduce((acc, val) => acc + val, 0)
        this.legendData[1].value = subscBasic.reduce((acc, val) => acc + val, 0)
        this.legendData[2].value = subscPro.reduce((acc, val) => acc + val, 0)

        const dateLabels = []
        const cursor = new Date(this.dateRange.startDate)
        const endDate = new Date(this.dateRange.endDate)
        while (cursor <= endDate) {
          dateLabels.push(YEAR_MONTH_DAY(cursor))
          cursor.setDate(cursor.getDate() + 1)
        }

        this.subscSeriesData = { starter: subscStarter, basic: subscBasic, pro: subscPro }

        this.legendData.forEach((_, i) => { this.legendData[i].active = true })
        this.legendDataRevenue.forEach((_, i) => { this.legendDataRevenue[i].active = true })

        const subscriptionSeries = [
          { name: 'Starter', data: subscStarter },
          { name: 'Basic', data: subscBasic },
          { name: 'Pro', data: subscPro },
        ]
        const allSeries = [
          { name: 'All Revenue', data: totalByDate },
          { name: 'Subscription', data: subscByDate },
          { name: 'Closing Order', data: closingByDate },
          { name: 'Broadcast', data: broadcastByDate },
        ]
        const seriesMap = {
          all_revenue: allSeries,
          subscription: subscriptionSeries,
          closing_order: [allSeries[2]],
          broadcast: [allSeries[3]],
        }
        const colorsMap = {
          all_revenue: this.legendDataRevenue.map(item => item.color),
          subscription: this.legendData.map(item => item.color),
          closing_order: [this.legendDataRevenue[2].color],
          broadcast: [this.legendDataRevenue[3].color],
        }

        this.series = seriesMap[filter] || allSeries
        this.fullSeriesData = this.series

        const interval = Math.max(1, Math.ceil(dateLabels.length / 16))
        const labelIndexMap = new Map(dateLabels.map((d, i) => [d, i]))

        const allValues = this.series.flatMap(s => s.data || [])
        const maxValue = allValues.length > 0 ? Math.max(...allValues) : 0
        const yMax = maxValue > 0 ? Math.ceil(maxValue * 1.25) : 100

        this.chartOptions = {
          ...this.chartOptions,
          colors: colorsMap[filter] || colorsMap.all_revenue,
          xaxis: {
            ...revenueChartOptions.xaxis,
            categories: dateLabels,
            labels: {
              ...revenueChartOptions.xaxis.labels,
              formatter: value => {
                const idx = labelIndexMap.get(value)
                if (idx == null || idx % interval !== 0) return ''
                const parts = value.split('-').map(Number)
                return parts.length === 3 ? parts[2] : value
              },
            },
          },
          yaxis: {
            ...revenueChartOptions.yaxis,
            min: 0,
            max: yMax,
          },
          tooltip: {
            ...this.chartOptions.tooltip,
            x: {
              formatter: (value, opts) => {
                const idx = opts && opts.dataPointIndex != null ? opts.dataPointIndex : -1
                const label = idx >= 0 ? dateLabels[idx] : null
                if (!label) return value
                return DAY_MONTH_YEAR(label)
              },
            },
          },
        }
      } catch {
        this.$toast_error({ message: 'Gagal ambil data revenue metrics' })
      } finally {
        this.loadingChart = false
      }
    },
  },
}
</script>

<style scoped>
.legend-card {
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  flex: 1;
  max-width: 148px;
  transition: all 0.3s ease;
}

.legend-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.legend-card-inactive {
  opacity: 0.5;
  background: #F3F4F6;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  transition: background-color 0.3s ease;
}

.gap-3 {
  gap: 1rem;
}

.cursor-pointer {
  cursor: pointer;
}

.year-picker-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  border: 1px solid #ECE9F1;
  border-radius: 4px;
  padding: 0.4rem 1rem;
  background: white;
  cursor: pointer;
}

.year-picker-wrapper:hover {
  border-color: #D1D5DB;
}

.year-picker-icon {
  width: 16px;
  height: 16px;
  pointer-events: none;
}

.year-picker-wrapper>>>.year-picker-container {
  border: none !important;
}

.year-picker-wrapper>>>.year-picker-input {
  border: none !important;
  outline: none !important;
  background: transparent !important;
  padding: 0 !important;
  width: 60px;
  cursor: pointer;
  font-size: 14px;
  color: #000;
}

.year-picker-wrapper>>>.year-picker-calendar {
  z-index: 1000;
  margin-top: 4px;
  right: 0;
  left: auto !important;
}

.year-picker-wrapper>>>.vdp-datepicker__calendar {
  right: 0;
  left: auto !important;
}
</style>
